import React from "react";
import AudiencePage from "@/components/AudiencePage";
import { AUDIENCES } from "@/data/content";

export default function StudentPage() {
  return <AudiencePage config={AUDIENCES.student} />;
}
